/* ZCT_V22_AUFTRAG (E3): „Auftragsarbeit anfragen“ wie CustomOrderForm in v21 (JS-042).
   Knopf öffnet: .co-expand bekommt co-open (Desktop klappt auf), zusätzlich .co-overlay (Handy-Fenster); beide Formulare
   teilen dieselben Eingaben. Senden per POST an den Worker /inquiry (name, email, message, product, lang) wie die
   reparierte Fassung in v21; Erfolg zeigt „Anfrage gesendet“, Fehler die Meldung über den Knöpfen. Schließen setzt zurück. */
(function () {
  'use strict';
  function zctT(k) { try { var el = document.getElementById('zct-texte'), d = el ? JSON.parse(el.textContent) : {}; var v = d[k]; if (typeof v === 'string' && v.indexOf('&') >= 0) { var t = document.createElement('textarea'); t.innerHTML = v; v = t.value; } return v == null ? '' : v; } catch (e) { return ''; } }
  var WORKER = 'https://zincutec-api.zincutec.workers.dev/inquiry';
  function texte() { var el = document.getElementById('zct-texte'); try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; } }
  var T = texte();
  function ent(s) { if (typeof s !== 'string' || s.indexOf('&') < 0) return s; var t = document.createElement('textarea'); t.innerHTML = s; return t.value; }
  function tx(k) { return T[k] != null ? ent(T[k]) : k; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  var ICON_CHECK = '<svg class="ico " viewBox="0 0 16 16"><path d="M3 8l3 3 7-7"></path></svg>';
  var ICON_CLOSE = '<svg class="ico " viewBox="0 0 16 16"><path d="M3 3l10 10M13 3L3 13"></path></svg>';
  var ICON_MAIL = '<svg class="ico " viewBox="0 0 16 16"><g><rect x="1.5" y="3.5" width="13" height="9" rx="1"></rect><path d="M1.5 4.5l6.5 5 6.5-5"></path></g></svg>';

  function einrichten(wrap) {
    if (wrap._zctAuftrag) return;
    wrap._zctAuftrag = true;
    var startKnopf = wrap.querySelector(':scope > button.btn');
    var expand = wrap.querySelector(':scope > .co-expand');
    var formVorlage = expand.innerHTML;
    var st = { offen: false, gesendet: false, name: '', email: '', objekt: '', vision: '', sendet: false, fehler: null };

    function felder(form) { var i = form.querySelectorAll('input'); return { name: i[0], email: i[1], objekt: i[2], vision: form.querySelector('textarea') }; }
    function gesendetHtml() {
      return '<div class="co-form co-sent"><div class="co-sent-icon">' + ICON_CHECK + '</div><div class="co-sent-title">' + esc(tx('auftrag_gesendet')) + '</div><p>' + esc(tx('auftrag_danke')) +
        ' <a href="mailto:shop@zincutec.eu">shop@zincutec.eu</a></p><button class="btn sm ghost" style="margin: 0px auto;" data-zct-co-zu>' + esc(tx('auftrag_schliessen')) + '</button></div>';
    }
    function formFuellen(container) {
      var form = container.querySelector('form.co-form');
      if (!form) return;
      var f = felder(form);
      f.name.value = st.name; f.email.value = st.email; f.objekt.value = st.objekt; f.vision.value = st.vision;
      var fehler = form.querySelector('.co-error');
      if (st.fehler) {
        if (!fehler) { fehler = document.createElement('div'); fehler.className = 'co-error'; form.querySelector('.co-actions').before(fehler); }
        if (fehler.textContent !== st.fehler) fehler.textContent = st.fehler;
      } else if (fehler) fehler.remove();
      var senden = form.querySelector('button[type="submit"]');
      senden.disabled = st.sendet;
      var beschriftung = st.sendet ? esc(tx('auftrag_sendet')) + ' ' : esc(tx('auftrag_absenden')) + ' ' + ICON_MAIL;
      if (senden.innerHTML !== beschriftung) senden.innerHTML = beschriftung;
    }
    // Wie React: vorhandene Knoten bleiben stehen (Fokus, Auswahl), nur Geändertes wird gesetzt
    function inhaltSetzen(container) {
      if (st.gesendet) { if (!container.querySelector('.co-sent')) container.innerHTML = gesendetHtml(); return; }
      if (!container.querySelector('form.co-form')) container.innerHTML = formVorlage;
      formFuellen(container);
    }
    function zeichnen() {
      if (st.offen) { if (startKnopf.isConnected) startKnopf.remove(); }
      else if (!startKnopf.isConnected) wrap.prepend(startKnopf);
      var k = 'co-expand ' + (st.offen ? 'co-open' : '');
      if ((expand._zctZiel || expand.className) !== k) hoeheAnimieren(k);
      inhaltSetzen(expand);
      var overlay = wrap.querySelector(':scope > .co-overlay');
      if (st.offen) {
        if (!overlay) {
          overlay = document.createElement('div'); overlay.className = 'co-overlay';
          overlay.innerHTML = '<div class="co-overlay-modal"><button type="button" class="co-overlay-close" aria-label="Close" data-zct-co-zu>' + ICON_CLOSE + '</button><div class="co-overlay-header"><div class="co-overlay-eyebrow">' +
            esc(tx('auftrag_auftragsarbeit')) + '</div><h2>' + esc(tx('auftrag_deine_vision')) + '</h2></div><div class="co-overlay-body"></div></div>';
          wrap.appendChild(overlay);
        }
        inhaltSetzen(overlay.querySelector('.co-overlay-body'));
      } else if (overlay) overlay.remove();
    }
    // Paket D (Bewegung): Auf- und Zuklappen am Desktop als Höhe per WAAPI, 200 ms kräftiges ease-out wie die übrigen Aufklapper
    // (vorher max-height über 500 ms mit Verzögerung beim Schließen). Unterbrechbar: startet an der aktuellen Höhe.
    // „Bewegung reduzieren“ und Handy (Fenster statt Aufklapper): ohne Animation.
    function hoeheAnimieren(k) {
      var oeffnen = k.indexOf('co-open') >= 0;
      var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (ruhig || getComputedStyle(expand).display === 'none' || !expand.animate) {
        expand.getAnimations().forEach(function (a) { a.cancel(); }); expand._zctZiel = null; expand.className = k; return;
      }
      // aktueller Stand (auch mitten in einer laufenden Animation), dann diese abbrechen und von hier aus weiter
      var von = expand.getBoundingClientRect().height, opVon = parseFloat(getComputedStyle(expand).opacity) || 0;
      expand.getAnimations().forEach(function (a) { a.cancel(); });
      expand._zctZiel = k;
      expand.className = 'co-expand co-open';   // während der Animation sichtbar, Endzustand setzt onfinish
      inhaltSetzen(expand);
      var bis = oeffnen ? Math.min(expand.scrollHeight, 600) : 0;
      expand.style.overflow = 'hidden';
      var anim = expand.animate([{ height: von + 'px', maxHeight: 'none', opacity: opVon }, { height: bis + 'px', maxHeight: 'none', opacity: oeffnen ? 1 : 0 }], { duration: 200, easing: 'cubic-bezier(0.23, 1, 0.32, 1)' });
      anim.onfinish = function () { expand.style.overflow = ''; expand._zctZiel = null; expand.className = k; };
      anim.oncancel = function () { expand.style.overflow = ''; };
    }

    // Schließen wie close() in v21: Fehlermeldung und Sendezustand bleiben unberührt
    function zu() { st.offen = false; st.gesendet = false; st.name = ''; st.email = ''; st.objekt = ''; st.vision = ''; zeichnen(); }

    startKnopf.addEventListener('click', function () { st.offen = true; zeichnen(); });
    wrap.addEventListener('click', function (e) {
      if (e.target.closest('[data-zct-co-zu]') || e.target.closest('.co-cancel')) { e.preventDefault(); zu(); }
    });
    // Eingaben in beiden Formularen gleich halten (in v21 ein gemeinsamer Zustand)
    wrap.addEventListener('input', function (e) {
      var form = e.target.closest('form.co-form'); if (!form) return;
      var f = felder(form);
      st.name = f.name.value; st.email = f.email.value; st.objekt = f.objekt.value; st.vision = f.vision.value;
      wrap.querySelectorAll('form.co-form').forEach(function (andere) {
        if (andere === form) return;
        var g = felder(andere); g.name.value = st.name; g.email.value = st.email; g.objekt.value = st.objekt; g.vision.value = st.vision;
      });
    });
    wrap.addEventListener('submit', function (e) {
      var form = e.target.closest('form.co-form'); if (!form) return;
      e.preventDefault();
      st.sendet = true; st.fehler = null; zeichnen();
      // Anfrage-Text in der Sprache des Mail-Servers (nur Deutsch und Englisch): Deutsch auf Deutsch, sonst Englisch
      var de = zctT('termin_v25_worker_sprache') === 'de', en = !de;
      var val = function (v) { return String(v || '').trim(); };
      var msg = [de ? 'Anfrage Auftragsarbeit (Maßanfertigung)' : 'Custom order request', '', (de ? 'Objekt' : 'Piece') + ': ' + (val(st.objekt) || (de ? 'keine Angabe' : 'not provided')), '',
        (de ? 'Vision' : 'Vision') + ':', val(st.vision) || (de ? 'keine Angabe' : 'not provided')].join('\n');
      fetch(WORKER, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ name: val(st.name), email: val(st.email), message: msg,
        product: val(st.objekt) ? (de ? 'Auftragsarbeit: ' : 'Custom order: ') + val(st.objekt) : (de ? 'Auftragsarbeit' : 'Custom order'), lang: en ? 'en' : 'de' }) })
        .then(function (r) { return r.json(); })
        .then(function (json) { if (json.ok) st.gesendet = true; else st.fehler = json.error || tx('auftrag_fehler'); })
        .catch(function () { st.fehler = tx('auftrag_fehler'); })
        .finally(function () { st.sendet = false; zeichnen(); });
    });
  }
  function start() { document.querySelectorAll('.co-wrap').forEach(einrichten); }
  window.zctAuftragStart = start;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
